// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mUml","type":"styles_type__2SsAW","choices":"styles_choices__3rMre"};